import { ClaimGift, ClaimGiftResponse } from '@/core/interfaces';

export const ClaimGiftMapper = ({
	collectionID,
	collectionTitle,
	isCollectionCompleted,
	isStickerRepeated,
	sticker,
}: ClaimGiftResponse): ClaimGift => {
	const claimGiftData: ClaimGift = {
		collection: collectionID,
		collectionTitle: collectionTitle,
		isCollectionCompleted: isCollectionCompleted,
		sticker: {
			position: sticker.position,
			image: sticker.imageUrl,
		},
		isStickerRepeated: isStickerRepeated,
	};

	return claimGiftData;
};
